/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Uploadcsv1Inputs */

const en_common_uploadcsv1 = /** @type {(inputs: Common_Uploadcsv1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upload .csv`)
};

/**
* | output |
* | --- |
* | "Upload .csv" |
*
* @param {Common_Uploadcsv1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const common_uploadcsv1 = /** @type {((inputs?: Common_Uploadcsv1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Uploadcsv1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_common_uploadcsv1(inputs)
});
export { common_uploadcsv1 as "common_uploadCsv" }